import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { filterChange, filterRemove } from "../../features/filter/filterSlice";

export default function Project({ project }) {
  const [filter, setFilter] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (filter) dispatch(filterChange(project.id));
    if (!filter) dispatch(filterRemove(project.id));
  }, [filter, dispatch, project]);
  const handleCheck = (e) => {
    setFilter(!e.target.checked);
  };
  return (
    <div className="checkbox-container">
      <input
        type="checkbox"
        className={project.colorClass}
        checked={!filter}
        onChange={handleCheck}
      />
      <p className="label">{project.projectName}</p>
    </div>
  );
}
